import React from 'react';
import PageRepList from 'pages/DealerAdmin/RepList';

export const UsersTab = () => {
  return <PageRepList />;
};
